export class DialogModelSearchByOrder {
    constructor(
      public orderId: any
    ) {}
  }
  